/**
 * M. Eugène mark (bowler hat and moustache), drawn in `currentColor` so the frame that hosts it
 * (`BrandLockup` in the design system) gives it the primary color of the theme.
 * Cropped to the drawing; the full-square original lives in `public/favicon.svg`.
 */
export default function BrandLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="13 19 74 62" fill="currentColor" focusable="false">
      <path d="M27.75 35 A24 24 0 0 1 72.25 35 Z" />
      <path d="M26.19 41 L73.81 41 A24 24 0 0 1 74 44 L26 44 A24 24 0 0 1 26.19 41 Z" />
      <path d="M27.2 41 A23 23 0 0 1 28.83 35 M71.17 35 A23 23 0 0 1 72.8 41" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="14" y="42" width="72" height="9" rx="4.5" />
      <path d="M50 70 C44 63 34 63 30 69 C27 73 22 73 19 68 C19 77 30 82 38 78 C43 76 47 74 50 72 C53 74 57 76 62 78 C70 82 81 77 81 68 C78 73 73 73 70 69 C66 63 56 63 50 70 Z" />
    </svg>
  );
}
